module.exports = __webpack_public_path__ + "static/media/Rain.7e0f28b3.svg";